<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" type="error" class="chaxun">查询</Button>
        <Button @click="openAdd" type="primary" class="chaxun">新增</Button>
      </div>
    </div>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增数据' : '编辑数据'" fullscreen ref="formModel">
      <renyuanList ref="renyuanList" slot="dayList"></renyuanList>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
var yyyy = new Date().getFullYear(),
  mm = new Date().getMonth();
var months = [
  "一",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
  "十一",
  "十二",
];
import axios from "axios";
import selectFlow from "./selectFlow.vue";
import renyuanList from "./renyuanpaibanTime.vue";
export default {
  components: { selectFlow, renyuanList },
  data() {
    return {
      openForm: false,
      openNextForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "名称",
          key: "name",
        },
        {
          title: "项目名称",
          key: "groupName",
        },
        {
          title: "养护单位",
          key: "unit",
        },
        {
          title: "开始时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startDate, "yymmdd"));
          },
        },
        {
          title: "结束时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endDate, "yymmdd"));
          },
        },
        {
          title: "创建者账号",
          key: "createAccount",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],

      item: {
        groupId: "",
        groupName: "",
        flowId: "1611273939011809286",
        flowName: "",
        name: '',
        title: "我的标题",
        startDate: new Date(yyyy, mm, 1).getTime(),
        endDate: new Date(yyyy, mm + 1, 1).getTime() - 1000,
        dayList: [],
        remark: "",
        unit: ''
      },
      ruleValidate: {},

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      forms: [
        {
          title: "排班名称",
          key: "name",
          key1: "name",
          type: "Input",
          span: 6,
        },
        {
          title: "开始时间",
          key: "startDate",
          type: "lyyymmdd",
          required: true,
          span: 6,
        },
        {
          title: "结束时间",
          key: "endDate",
          type: "lyyymmdd",
          required: true,
          span: 6,
        }, {
          title: "流程名称",
          key: "flowId",
          type: "Select",
          selectType: "obj",
          selectItems: [
            {
              id: "1611273939011809286",
              name: "日常保洁流程",
            },
            {
              id: "1637655498083803137",
              name: "日常巡查流程",
            },
          ],
          required: true,
          span: 6,
        },
        {
          title: "项目名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
          span: 6,
        },
        {
          title: "养护单位",
          key: "unit",
          type: "Select",
          selectItems: [
            "广东华政建设有限公司", "珠海虹筑建设有限公司", "广东威恒建设工程有限公司", "广东信婷建设劳务有限公司", "珠海德康泰实业有限公司", "广东致盛建设工程有限公司", "珠海锦裕劳务有限公司", "广东程达路桥有限公司", "东部大桥项目",
          ],
          //required: true,
          span: 6,
        },

        {
          title: "备注信息",
          key: "remark",
          key1: "remark",
          type: "Input",
          required: false,
          span: 6,
        },
        {
          title: "排班信息",
          key: "dayList",
          slotForm: "dayList",
          required: true,
          hideLabel: true,
          span: 24,
        },
      ],
    };
  },
  computed: {
    startDate() {
      return this.item.startDate;
    },
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.flow + "/schedule/list",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);

        this.tableData = data;
      });
    },
    addUpdate(name) {
      var m = this.$refs.renyuanList.bToA();
      if (!this.isAdd) {
        for (let i = 0; i < m.length; i++) {
          m[i].id = this.item.id;
        }
      }
      this.item.dayList = m;
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      console.log(33, this.item);

      this.utils.loading(this, "处理中");
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.flow + "/schedule/add",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.flow + "/schedule/update",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.flow + "/schedule/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },

    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
      this.$refs.formModel.reach(this.forms, this.item);
      setTimeout(() => {
        this.$refs.renyuanList.reach(this.item.dayList, this.isAdd);
      }, 200);
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
      setTimeout(() => {
        this.$refs.renyuanList.reach(this.item.dayList, this.isAdd);
        this.$refs.renyuanList.changeTime(this.item);
      }, 200);
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    rule() {
      var arr = this.forms;
      var abc = {};

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].required) {
          abc[arr[i].key1] = { required: true, message: "必填" };
        }
      }
      this.ruleValidate = abc;
    },
  },
  mounted() {
    this.chaxun();
    //this.$refs.renyuanList.changeTime(this.item);
  },
  created() {
    this.rule();
  },
  watch: {
    startDate(v) {
      var s = new Date(v);
      this.item.endDate =
        new Date(s.getFullYear(), s.getMonth() + 1, 1).getTime() - 1000;

      this.$refs.renyuanList.changeTime(this.item);
    },
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/yhgl/renyuanpaiban.vue